<!--
 * @Description:
 * @Version: 2.0
 * @Autor: lau
 * @Date: 2022-08-19 11:44:37
 * @LastEditors: lau
 * @LastEditTime: 2022-08-23 16:52:52
-->
<!-- 获取单个停车场空车位接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
             "parkCode":"123"
            },
            responseCode: {
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台 获取停车区域信息",
                t_url: this.commonUrls.test+"getParkingAreaInfo",
                p_url: this.commonUrls.prod+"getParkingAreaInfo",
                precondition: "无",
                fitSystem: "云停车场 (智汇云)",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                            { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' }
                        ]
                },

                ],
                R_params: [ {
                  titleName: null,
                  tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                  td: [
                    { info1: 'areaBaseInfos', info2: '是', info3: 'String', info4: '区域信息列表' },
                  ]
                }, {
                  titleName: "areaBaseInfos",
                  tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                  td: [
                    { info1: 'areaId', info2: '是', info3: 'String', info4: '区域id' },
                    { info1: 'areaCode', info2: '是', info3: 'String', info4: '区域编码' },
                    { info1: 'areaName', info2: '是', info3: 'Integer', info4: '区域名称' },
                    { info1: 'parkCode', info2: '是', info3: 'Integer', info4: '车场编码' },
                  ]
                },],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/park/area/getParkingAreaInfo.vue